<template>
    <div class="not-found-view">
        <img src="../../assets/img/401.gif" class="logo" />
        <div class="group">
            <h1 class="title">401</h1>
            <p class="desc">对不起，您没有权限去该页面！</p>
            <el-button type="primary" class="to-home" @click.stop.prevent="toHome">返回首页</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NotPermission',
    methods: {
        toHome () {
            this.$router.push({
                path: '/'
            })
        }
    }
}
</script>
<style scoped lang="less">
.not-found-view{
    display: -webkit-box;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    -webkit-box-orient: vertical;
    height: 100VH;
    padding-bottom: 10%;
    box-sizing: border-box;
    .logo{
        display: block;
        width: 220px;
    }
    .group{
        margin-top: 3%;
        text-align: center;
        margin-left: -75px;
    }
    .title{
        color: #1f1f1f;
        font-size: 30px;
        text-align: center;
    }
    .desc{
        color: #1f1f1f;
        font-size: 18px;
        text-align: center;
        padding-top: 15px;
    }
    .to-home{
        margin-top: 40px;
    }
}
</style>